import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PortalProducts } from '@shared/enumeration';

@Component({
    selector: 'dmepos-provider-dashboard-wrapper',
    template: `
    <mnc-dmepos-provider-dashboard
      lazyComponent
      [tenantId]="tenantId"
      (routeToAuthRequest)="routeToAuthRequest($event.detail)"
    ></mnc-dmepos-provider-dashboard>
  `,
    standalone: false
})
export class ProviderDashboardComponent {
  public tenantId: string;

  constructor(private route: ActivatedRoute, private router: Router) {
    const { tenantId } = this.route.snapshot.params;
    this.tenantId = tenantId;
  }

  routeToAuthRequest(
    { subscriberNumber, authorizationByProductId }: { subscriberNumber: string, authorizationByProductId: string }
  ): void {
    this.router.navigate(
      [
        this.tenantId,
        PortalProducts.DMEPOS,
        'member',
        subscriberNumber,
        'request-initial',
        authorizationByProductId
      ],
      { queryParams: { tab: 4 } }
    );
  }
}
